import Container from "./EnterpriseUpdateStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";

import { useEffect, useRef, useState } from "react";
import { AxiosRequestConfig } from "axios";
import PageTitle from "../../components/PageTitle";


export default function EnterpriseUpdate(props) {

  const [loading, setLoading] = useState(false);
  const [errorEditing, setErrorEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [dragOver, setDragOver] = useState(false);
  const [dragEnters, setDragEnters] = useState(0);
  const [invalidFiles, setInvalidFiles] = useState(false);

  const [photosAttached, setPhotosAttached] = useState([] as File[]);
  const [photosToDelete, setPhotosToDelete] = useState([] as number[]);

  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [externalPhotos, setExternalPhotos] = useState([] as any);


  const enterpriseId = props.match.params.enterpriseId;
  const updateId = props.match.params.updateId;

  const creatingNew = updateId < 0;
  const inputFile = useRef(null)

  useEffect(() => {
    if (!creatingNew)
      LoadUpdateDetails();
  }, []);

  async function LoadUpdateDetails() {
    setLoading(true);
    try {
      const result = await api.get(`enterprises/${enterpriseId}/updates/${updateId}`);
      if (!result.data.success) {
        setLoading(false);
        setErrorMessage(result.data.error);
        return;
      }
      const update = result.data.update;

      if (!update) {
        setErrorEditing(true);
        setErrorMessage("Não foi possível pegar os dados da tarefa");
        console.error(`Não há tarefa com id: ${updateId} na lista de tarefas`);
        return;
      }
      const { name, text, photos } = update;
      setName(name);
      setText(text);
      setExternalPhotos(photos);
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      setErrorEditing(true);
      setErrorMessage("Não foi possível pegar os dados da tarefa");
      console.error(error);
    }
  }

  async function OnSubmit() {

    try {
      const formData = new FormData();
      const options: AxiosRequestConfig = {};
      if (photosAttached.length > 0) {
        for (const photoIndex in photosAttached) {
          const photo = photosAttached[photoIndex];
          formData.append("photos", photo, photo.name);
        }
        options.onUploadProgress = progressEvent => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor(loaded * 100 / total);
          SetUploadProgress(percentage);
          console.log(`${loaded / 1024}kb of ${total / 1024}kb | ${percentage}% photo uploaded`);
        }
      }
      if (photosToDelete.length > 0 && !creatingNew) {
        photosToDelete.map(photoId => formData.append("photosToDelete", photoId.toString()));
        options.onUploadProgress = progressEvent => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor(loaded * 100 / total);
          SetUploadProgress(percentage);
          console.log(`${loaded / 1024}kb of ${total / 1024}kb | ${percentage}% photo uploaded`);
        }
      }
      formData.append("updateName", name);
      formData.append("updateText", text);
      setLoading(true);
      const request = creatingNew ? api.post(`/enterprises/${enterpriseId}/updates`, formData, options) : api.put(`/enterprises/${enterpriseId}/updates/${updateId}`, formData, options);
      const result = await request;
      setLoading(false);
      if (result.data.success)
        props.history.goBack()
      else {
        setErrorEditing(true);
        setErrorMessage(JSON.stringify(result.data));
      }

    }
    catch (error) {
      setErrorEditing(true);
      setErrorMessage("Não foi possível alterar atualização, erro no servidor!");
      console.error(error);
      setLoading(false);
    }
  }

  function SetUploadProgress(percentage) {

  }

  function ValidFiles(items: File[]): boolean {
    return items.every(item => {
      const fileType = item.type.split("/");
      return fileType.length > 0 ? fileType[0] === "image" : false;
    });
  }

  function FileListToArray(fileList: FileList) {
    let files: File[] = [];
    for (let i = 0; i < fileList.length; i++)
      files.push(fileList[i]);
    return files;
  }

  function GetTitle(): string {
    if (invalidFiles)
      return "Algum arquivo inválido, escolha apenas imagens";
    else if (dragOver)
      return "Solte para subir";
    else
      return "Arraste as fotos"
  }

  function GetPhotoPreview(url: string, index: number, OnClickRemove) {
    return (
      <div key={index} id="photoPreview">
        <img alt={`Foto anexada ${index + 1}`}
          src={GetPhotoUrl(url, index)} />
        <button id="removePhoto"
          onClick={e => {
            e.preventDefault();
            OnClickRemove(index);
          }}
        >X</button>
      </div>
    )
  }

  function GetPhotoUrl(url, index) {
    if (url.startsWith("FILE-S3://")) {
      return `${process.env.REACT_APP_BASE_URL}/enterprises/updates/photos/${index}`;
    }
    else
      return url;
  }

  function OnAttachPhotos(photosFileList: FileList) {
    let photos: File[] = [];
    for (let i = 0; i < photosFileList.length; i++)
      photos.push(photosFileList[i]);

    console.log("Anexou foto");
    setPhotosAttached(photosAttached.concat(photos));
  }

  function HandleDrop(e) {
    if (!invalidFiles)
      OnAttachPhotos(e.dataTransfer.files)
    setDragOver(false);
    setInvalidFiles(false);
    e.preventDefault();
    e.stopPropagation();
  }
  function HandleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  function HandleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragEnters(dragEnters + 1);
    if (e.dataTransfer.items.length === 0) {
      setInvalidFiles(true);
      return;
    }

    if (!ValidFiles(FileListToArray(e.dataTransfer.items))) {
      setInvalidFiles(true);
      return;
    }

    setDragOver(true);
    setInvalidFiles(false);
  }

  function HandleDragLeave(e) {
    const newDragEnters = Math.max(0, dragEnters - 1);
    setDragOver(newDragEnters > 0);
    setDragEnters(newDragEnters);
    if (newDragEnters === 0)
      setInvalidFiles(false);
    e.preventDefault();
    e.stopPropagation();
  }

  function HandleDragEnd(e) {
    setDragOver(false);
    setDragEnters(0);
    setInvalidFiles(false);
    e.preventDefault();
    e.stopPropagation();
  }

  function OnClickUploadFile(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!inputFile || !inputFile.current) {
      console.error("Não foi possível abrir dialog de arquivos pois está sem input file");
      return;
    }
    // @ts-ignore: Object is possibly 'null'.
    inputFile.current.click();
  }

  function OnAttachFiles(e) {
    if (!ValidFiles(FileListToArray(e.target.files))) {
      console.log("Arquivo invalido");
      setInvalidFiles(true);
      return;
    }
    else
      setInvalidFiles(false);

    console.log("Arquivo valido");
    OnAttachPhotos(e.target.files)
  }

  function RemoveAttachedPhoto(index) {
    console.log("index", index);
    if (photosAttached.length <= 1)
      setPhotosAttached([]);
    else {
      const oldPhotosAttached = [...photosAttached];
      oldPhotosAttached.splice(index, 1);
      setPhotosAttached(oldPhotosAttached);
    }
  }

  function RemoveExternalPhoto(id: number) {
    console.log("Remover photo remota");
    setPhotosToDelete(photosToDelete.concat(id));
  }

  return (
    <Container>
      <PageTitle title="Atualização do Empreendimento" />
      <div>
        <button onClick={() => props.history.goBack()} className="btn btn-secondary">Voltar</button>

        <form className="defaultForm" onSubmit={
          (e) => {
            e.preventDefault();
            OnSubmit();
          }}>
          <Spinner spinning={loading} />
          {errorEditing && <p className="alert">Erro: {errorMessage}</p>}

          <h1>Atualização</h1>
          <div>
            <label>Nome:</label>
            <input

              disabled={loading}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div>
            <label>Descrição:</label>
            <textarea
              className="largeInput"
              disabled={loading}
              value={text}
              onChange={e => setText(e.target.value)}
            />
          </div>

          <div
            className={`multipleFileUpload ${dragOver && "activeContainer"} ${invalidFiles && "invalidDrag"}`}
            onDrop={HandleDrop}
            onDragOver={HandleDragOver}
            onDragEnter={HandleDragEnter}
            onDragLeave={HandleDragLeave}
            onDragEnd={HandleDragEnd} >
            <h1 id="dragTitle">{GetTitle()}</h1>
            <div id="gallery">
              <button id="uploadFile" className="btn btn-lg" onClick={OnClickUploadFile}>Adicionar foto</button>
              {
                photosAttached.length > 0 && photosAttached.map((photoFile, index) => {
                  console.log("photos attached length: ", photosAttached.length);
                  const initialIndex = externalPhotos.length > 0 ?
                    externalPhotos.map(photo => photo.id).reduce((photo, currentMax) => Math.max(photo, currentMax)) + 1 : 0;
                  return GetPhotoPreview(URL.createObjectURL(photoFile), initialIndex + index, RemoveAttachedPhoto);
                })
              }
              {
                externalPhotos.length > 0 &&
                externalPhotos.filter(externalPhoto => !photosToDelete.includes(externalPhoto.id)).map((photo, index) => {
                  console.log("external photos length: ", externalPhotos.length);
                  return GetPhotoPreview(photo.url, photo.id, RemoveExternalPhoto);
                })
              }
            </div>
          </div>

          <button
            className="btn btn-success btn-lg mt-4"
            type="button"
            disabled={loading}
            onClick={e => {
              e.preventDefault();
              OnSubmit();
            }}>{creatingNew ?
              "Adicionar atualização" :
              "Editar atualização"}
          </button>
          <input type="file" id="file" onChange={OnAttachFiles} value="" accept="image/*" ref={inputFile} multiple></input>
        </form>

      </div >
    </Container >
  );
}